import { motion } from 'framer-motion';

const AdditionalServices = () => {
  const additionalServices = [
    {
      icon: 'ri-global-line',
      title: '国際税務',
      description: '国際税務研究会会員として能力を維持向上。外国税額控除等の国際税務に対応。外国人の方の確定申告や年金の脱退一時金還付申告も実績多数。',
      stats: '2012年：技能研修生64名、2013年：23名の還付申告実績'
    },
    {
      icon: 'ri-stock-line',
      title: '株価計算',
      description: '相続税申告に必要な株価計算のほか、裁判資料としての株価計算も対応。2012年には裁判所提出実績もあります。',
      stats: '相続・裁判資料として高い評価'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'その他専門サービス',
      description: '相続税・贈与税申告、年末調整、償却資産税申告、帳簿復元、不正調査、財務調査、大量保有報告書作成、株主総会議事録作成、記帳代行等',
      stats: '幅広い専門サービスに対応'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            その他の専門サービス
          </h2>
          <p className="text-gray-600 text-lg">
            幅広い専門知識で、あらゆる税務ニーズにお応えします
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {additionalServices.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-red/30 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-red to-red-light rounded-xl flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                {service.description}
              </p>
              <div className="inline-block bg-red/10 text-red px-3 py-1.5 rounded-full text-xs font-semibold">
                {service.stats}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;
